import React, { useState } from 'react';
import './NewIngredient.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewIngredient() {
    const [mensaje, setMensaje] = useState('');
    const [name, setName] = useState('');
    const [price, setPrice] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setName('');
        setPrice(0);
        setMensaje('');
        setModalOpen(!modalOpen);
    };


    const crear = async () => {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('price', price);

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/ingredientPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>+</span> Agregar
            </button>
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Ingrediente</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form className='flexGrap'>
                            <fieldset>
                                <legend>Nombre</legend>
                                <input
                                    type='text'
                                    placeholder='Nombre'
                                    name='name'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Precio</legend>
                                <input
                                    type='number'
                                    name='price'
                                    placeholder='Precio'
                                    value={price}
                                    min="0"
                                    step="0.1"
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </fieldset>
                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
